module.exports = __webpack_public_path__ + "static/img/peitu.dc17300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/system/peitu.png
// module id = 541
// module chunks = 12